import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Activity, FileCheck, Users } from 'lucide-react';

export default function UserActivityTab({ analytics, stats }) {
  return (
    <div data-testid="user-activity-tab">
      <h1 className="text-3xl font-bold text-slate-900 mb-6">User Activity</h1>
      <div className="grid grid-cols-2 gap-6 mb-6">
        <Card>
          <CardHeader><CardTitle>Active Users Today</CardTitle></CardHeader>
          <CardContent>
            <p className="text-4xl font-bold text-green-600">{analytics?.agents?.length || 5}</p>
            <p className="text-sm text-slate-500">Users logged in today</p>
          </CardContent>
        </Card>
        <Card>
          <CardHeader><CardTitle>Total System Users</CardTitle></CardHeader>
          <CardContent>
            <p className="text-4xl font-bold text-blue-600">{(analytics?.agents?.length || 5) + (stats?.total_vendors || 0) + 2}</p>
            <p className="text-sm text-slate-500">Registered users in system</p>
          </CardContent>
        </Card>
      </div>
      <Card>
        <CardHeader><CardTitle>Recent Activity Log</CardTitle></CardHeader>
        <CardContent>
          <div className="space-y-3">
            <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg">
              <Activity className="w-5 h-5 text-green-600" />
              <div>
                <p className="font-medium">Admin User logged in</p>
                <p className="text-xs text-slate-500">Just now</p>
              </div>
            </div>
            <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg">
              <FileCheck className="w-5 h-5 text-blue-600" />
              <div>
                <p className="font-medium">Case CASE001 updated</p>
                <p className="text-xs text-slate-500">5 minutes ago</p>
              </div>
            </div>
            <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg">
              <Users className="w-5 h-5 text-purple-600" />
              <div>
                <p className="font-medium">New vendor assigned</p>
                <p className="text-xs text-slate-500">15 minutes ago</p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
